import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { AmpLanding } from './AmpLanding.types';

export function useAmpLandingData(): Page<AmpLanding>['templateFields'] {
  return useCurrentPage<Page<AmpLanding>>().templateFields;
}
